<script>
  export let idUnico = 'sintese-1';
  export let content;

  let indexBegin;
  let indexEnd;
  let voce_finalizou;
  let contentCustom;
  let contentHtml;

  content = toItalic(content);

  indexBegin = content.search('{{');
  indexEnd = content.search('}}');

  if (indexBegin != -1 && indexEnd != -1) {
    voce_finalizou = content.substring(indexBegin + 2, indexEnd);

    voce_finalizou = voce_finalizou.split('==');

    contentCustom = content.replace(
      content.substring(indexBegin, indexEnd + 2),
      '<br><br><br><span class="voce-finalizou">' +
        voce_finalizou[0].trim() +
        '</span><br><span class="no-proximo">' +
        voce_finalizou[1].trim() +
        '</span>'
    );
  } else {
    contentCustom = content;
  }
</script>

<div class="sintese-header" id={idUnico}>
  <div class="titulo">
    <h2>Síntese do Módulo</h2>
  </div>
</div>

<div class="container" id={idUnico}>
  <p>
    {@html contentCustom}
  </p>
</div>

<style>
  .sintese-header {
    outline: dashed 1px #00000011;
    max-width: 40em !important;
    /* max-width: 710px !important; */
    min-width: 20em !important;
    /* margin-bottom: 1px; */
    padding: 0 0 0 6rem;
    position: relative;
    margin: 1rem auto 2rem auto;
    transform: translateX(-3rem);
    background-image: linear-gradient(to right, var(--VERDE_CLARO), var(--VERDE_CLARO));
    border-radius: 0 60px 60px 0;
    min-height: 120px;
    display: grid;
    grid-template-columns: 1fr;
    align-items: center;
  }
  .container {
    --Gradientes-Degrad-principal: linear-gradient(
      to right,
      var(--COR_MOD_TER),
      var(--COR_MOD_PRI)
    );
    --Gradientes-Degrad-principal-inv: linear-gradient(
      to right,
      var(--COR_MOD_PRI_20),
      var(--COR_MOD_TER)
    );
    --Principais-Texto: var(--COR_FONTE);
    --cor-primaria: var(--COR_MOD_PRI);
    --cor-secundaria: var(--COR_MOD_TER);
    --Infogrficos-Cinza: #e1e4e5;

    position: relative;
    margin-top: 30px;
    /*margin-bottom: 30px;*/
  }

  :global(a.anchor) {
    color: blue;
    font-weight: 500;
    text-decoration: underline;
  }
  :global(a.anchor:hover) {
    color: blue;
  }

  .titulo h2 {
    font-family: var(--FONT_INTER);
    width: fit-content;
    color: white;
    margin: 0 !important;
    font-weight: 500;
    font-size: 32px;
    font-style: italic;
  }

  :global(.voce-finalizou) {
    font-weight: 700;
    color: var(--MARROM);
  }

  :global(.no-proximo) {
    font-style: italic;
    color: var(--MARROM);
  }

  @media (max-width: 800px) {
    .sintese-header {
      transform: none;
      padding-left: 15px;
      min-height: 100px;
      max-width: 90%;
    }
    .titulo h2 {
      font-size: 28px;
    }
  }
</style>
